// Глобальная переменная
// eslint-disable-next-line no-undef
const isNotGbHost = !isGbHost;

const closePopupGtmTag = () => {
  isNotGbHost && window.$analytics?.push('close-popup-gtm-tag');
};

const initPagePush = () => {
  // Глобальные переменные
  // eslint-disable-next-line no-undef
  if (!!autopayment && amoId) {
    isNotGbHost && window.$analytics?.push('init-page-push');
  }
};

const accordionGtmTag = (eventName, value) => {
  const obj = {};

  obj.event = `${eventName}_view`;
  obj[`dl_${eventName}_name`] = value;  // зачем то разные ключи решили сделать

  isNotGbHost && window.$analytics?.push('accordion-gtm-tag', obj);
};

const clickButtonGtmTag = (clickType) => {
  isNotGbHost && window.$analytics?.push('click-button-gtm-tag', { clickType });
};

const submitFormGtmTag = (submitType, requestId, legalEntity, promoAccepted) => {
  isNotGbHost && window.$analytics?.push('submit-form-gtm-tag', { submitType, requestId, legalEntity, promoAccepted });
};

const successFormGtmTag = (submitType, requestId) => {
  isNotGbHost && window.$analytics?.push('success-form-gtm-tag', { submitType, requestId })
};

const failFormGtmTag = (submitType, {requestId, phone, email, errorCode, response: error}) => {
  const response = JSON.stringify(error);

  isNotGbHost && window.$analytics?.push('fail-form-gtm-tag', {
    submitType,
    requestId,
    phone,
    email,
    errorCode,
    response
  })
};

const showTrailerGtmEvent = (gtmEvent) => {
  if (gtmEvent) {
    isNotGbHost && window.$analytics?.push('show-trailer-gtm-event', { gtmEvent })
  }
};

export {
  closePopupGtmTag,
  clickButtonGtmTag,
  submitFormGtmTag,
  successFormGtmTag,
  failFormGtmTag,
  showTrailerGtmEvent,
  accordionGtmTag,
  initPagePush
};
